import { gql } from '@src/lib/gql'

export const CREATE_ADVISOR_CONNECT_DASHBOARD_LINK = gql`
  mutation CreateAdvisorConnectDashboardLink {
    createAdvisorConnectDashboardLink {
      url
    }
  }
`
